import { EventProperties } from '@lentau/analytics/health-metrics/shared';
import { checkEmptyFields } from '../utils';
import { PromotionsSearchResponseTypeWithoutParameters } from '@lentau/promo/promo-list-lnt/shared';

export function promoactionSearchHandler(body: PromotionsSearchResponseTypeWithoutParameters): EventProperties {
  {
    const fields = [
      {
        fieldToCheck: body?.PromoactionCount,
        errorName: 'PromoactionCountEmpty',
      },
    ];

    return checkEmptyFields(fields);
  }
}
